var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeavyMetals = function SvgHeavyMetals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#537A5E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.553 6.943-6.009-3.718-3.126.86m9.135 2.858-3.067 1.041m3.067-1.04 1.474 3.033-5.732 1.834m1.19-3.827-1.19 3.827m1.19-3.827-6.067-3.9m4.877 7.727L5.651 7.115l1.767-3.03M13.743 14.096l-3.082 1.11m3.082-1.11 1.32 3.2-5.301 1.903m3.981-5.103-.66-.463m-2.422 1.573-.9 3.993m.9-3.993L4.13 10.333M9.762 19.2l-7.463-5.845 1.83-3.02m0 0 1.763-.55M21.058 11.653l-3.345 1.132-.729 3.824 5.356-2.004zm0 0-.904-.526"
  }))));
};
export default SvgHeavyMetals;